import { useContext, useMemo, useState } from "react"
import ObjectDetailPartLeftCustomer from "./ObjectDetailPartLeftCustomer"
import ObjectDetailPartLeftList from "./ObjectDetailPartLeftList"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import BaseImageUpload from "../../../../components/elements/BaseImageUpload"
import { ReactComponent as QRCODE } from "../../../../assets/QrCode.svg"
import { Customer } from "../../../Kunden/types/Types"
import BaseSection from "../../../../components/elements/BaseSection"
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { useAddImageToObjectMutation } from "../../api/services"
import { GeneralQueryKeys } from "../../../../api/constants"
import { getImageFromObject } from "../../api/apiCalls"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"

type ObjectDetailPartLeftType = {
    id?: string
    customerData: Customer[]
    objectAdress: string
    customerId: string
    customerOfObject: string
    searchTermCustomer?: string
    setobjectData: (e: any) => void
    setsearchTermCustomer: (e: any) => void
    s3RefIsExisting: boolean
    lvdoesnotexist: boolean
    obvdoesexist: boolean
    objectsOffer: {
        nr: string | number | undefined
        _id: string
    }[]
    objectsBill: {
        nr: string | number | undefined
        billType: string
        _id: string
    }[]
    employeeData?: {
        first_name: string
        last_name: string
        _id: string
    }[]
}

export default function ObjectDetailPartLeft(props: ObjectDetailPartLeftType) {
    const modalCon = useContext(ModalContext)

    const urlParams = useMemo(() => {
        return {
            oid: props.id ?? "",
            adress: props.objectAdress,
            cid: props.customerId,
            customer: props.customerOfObject,
        }
    }, [props.id, props.customerId, props.objectAdress, props.customerOfObject])

    // Verwende den bestehenden Hook
    const [loading, setLoading] = useState(false)
    const { data } = useQuery({
        queryFn: () => getImageFromObject(props.id ?? ""),
        queryKey: [GeneralQueryKeys.OBJECT_SINGLE_IMAGE + props.id],
        enabled: props.s3RefIsExisting,
    })
    // Client der App (new QueryClient() erreichte die Bild-Query beim Invalidieren nicht)
    const queryClient = useQueryClient()
    const { mutate: addImage } = useAddImageToObjectMutation(queryClient, setLoading)

    return (
        <BaseSection responsive="md:flex md:flex-col md:overflow-x-hidden md:overflow-y-scroll" classProps="w-full md:w-1/2">
            <Authorized allOf={[P.objekte_read_write, P.buchhaltung_read]}>
                <BaseImageUpload setLoading={setLoading} loading={loading} data={data ?? ""} onUpload={(formData, done) => addImage({ id: props.id ?? "", img: formData }, done)} />
                <ObjectDetailPartLeftCustomer
                    searchTerm={props.searchTermCustomer}
                    customer={props.customerData}
                    customerOfObject={props.customerOfObject}
                    setobjectData={props.setobjectData}
                    setsearchTermCustomer={props.setsearchTermCustomer}
                />
                {/* OPEN OFFERS */}
                <ObjectDetailPartLeftList
                    headline="Gestellte Angebote:"
                    singular="Angebot"
                    newtext="Neues Angebot"
                    link="/buchhaltung/angebote/"
                    linknew={`/buchhaltung/angebote?${new URLSearchParams(urlParams).toString()}`}
                    objectListItems={props.objectsOffer}
                />
                {/* OPEN BILLS */}
                <ObjectDetailPartLeftList
                    headline="Gestellte Rechnungen:"
                    newtext="Neue Rechnung"
                    link="/buchhaltung/rechnung/"
                    linknew={`/buchhaltung/rechnungen?${new URLSearchParams(urlParams).toString()}`}
                    objectListItems={props.objectsBill}
                />
                <div className="flex flex-col justify-end w-full gap-2 p-2">
                    <button className="btn btn-outline" onClick={() => modalCon?.trigger(8)} type="button">
                        <QRCODE className="w-8 h-8" />
                    </button>
                    <button className="btn btn-outline" onClick={() => modalCon?.trigger(5)} type="button">
                        Leistungsverzeichnis
                    </button>
                    {props.obvdoesexist && (
                        <button className="btn btn-outline" disabled={props.lvdoesnotexist} onClick={() => modalCon?.trigger(7)} type="button">
                            Objektbetreuungsvertrag
                        </button>
                    )}
                </div>
            </Authorized>
        </BaseSection>
    )
}
